import BlockTeamMembers from './teamMembers'

export default BlockTeamMembers
